import React from 'react';
import _ from 'lodash';

import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
  TextInput,
  FormElementContainer,
} from '../CommonFormComponents';
import { CcusConnectingDialog } from '../modals/CcusConnectingDialog';
import { BackgroundLayer } from '../modals/BackgroundLayer';
import { CcusDescription } from '../CcusBase';
import ccusExplainImageOfOwner from '../../images/img-ccus-explain_owner.png';
import ccusExplainImageOfNotOwner from '../../images/img-ccus-explain_not_owner.png';
import { messageUtility } from '../../utilities/messageUtility';
import { Description } from '../Description';
import { TAB_KEY_STATUS } from '../../utilities/constants';

export const CcusCompanyForm = ({
  data,
  setValue,
  checkValidate,
  editPage,
  messageValidate,
  isLoadingCcus,
  isCCUSFormEditable,
  toggleShowPassword,
  isShowPass,
  togglePasswordVisible,
  passwordVisible,
  isOwner,
}) => {
  const {
    ccus_jigyousya_id,
    ccus_company_admin_id,
    ccus_company_admin_password,
  } = data;

  return (
    <div className='CcusForm'>
      <FormList>
        <FormListSubHeader title='CCUS基本情報' noMarginTop={true} />
        <FormElementContainer style={{ maxWidth: '960px' }}>
          <CcusDescription>
            <div>
              {isOwner && messageUtility.getMessage('I-001-455')}
              {!isOwner && !editPage && messageUtility.getMessage('I-001-516')}
              {!isOwner && editPage && messageUtility.getMessage('I-001-517')}
            </div>
          </CcusDescription>
          <Description style={{ marginBottom: '8px' }}>
            <div>
              {isOwner
                ? messageUtility.getMessage('I-001-457')
                : messageUtility.getMessage('I-001-518')}
            </div>
          </Description>
        </FormElementContainer>
        <FormListItem label='CCUS事業者ID' required={true}>
          <FormElement validate={_.get(messageValidate, 'ccus_jigyousya_id')}>
            <TextInput
              tabIndex={
                isCCUSFormEditable
                  ? TAB_KEY_STATUS.enabled
                  : TAB_KEY_STATUS.disabled
              }
              disabled={false}
              type='text'
              value={ccus_jigyousya_id}
              name='ccus_jigyousya_id'
              onChange={e => setValue(e, 'ccus_jigyousya_id')}
              onBlur={e => checkValidate(e, 'ccus_jigyousya_id')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='CCUS管理者ID（登録責任者）' required={true}>
          <FormElement
            validate={_.get(messageValidate, 'ccus_company_admin_id')}
          >
            <TextInput
              tabIndex={
                isCCUSFormEditable
                  ? TAB_KEY_STATUS.enabled
                  : TAB_KEY_STATUS.disabled
              }
              disabled={false}
              type='text'
              value={ccus_company_admin_id}
              onChange={e => setValue(e, 'ccus_company_admin_id')}
              onBlur={e => checkValidate(e, 'ccus_company_admin_id')}
            />
          </FormElement>
        </FormListItem>
        {editPage ? (
          <React.Fragment>
            <FormListItem
              label={
                isOwner ? 'CCUSログインパスワード' : 'CCUSセキュリティコード'
              }
            >
              <FormElement>
                <label>
                  <input
                    type='checkbox'
                    value={isShowPass}
                    onChange={() => toggleShowPassword(isShowPass)}
                  />
                  {isOwner
                    ? 'パスワードを編集する'
                    : 'セキュリティコードを編集する'}
                </label>
              </FormElement>
            </FormListItem>
            {isShowPass && (
              <FormListItem
                label={
                  isOwner
                    ? 'パスワード・セキュリティコード'
                    : 'CCUSセキュリティコード'
                }
                required={true}
                className='form-list__item form-list__item-password'
              >
                <FormElement
                  validate={_.get(
                    messageValidate,
                    'ccus_company_admin_password'
                  )}
                >
                  <TextInput
                    tabIndex={
                      isCCUSFormEditable
                        ? TAB_KEY_STATUS.enabled
                        : TAB_KEY_STATUS.disabled
                    }
                    disabled={false}
                    type={passwordVisible ? 'text' : 'password'}
                    name='ccus_company_admin_password'
                    value={ccus_company_admin_password}
                    autoComplete='new-password'
                    onChange={e => setValue(e, 'ccus_company_admin_password')}
                    onBlur={e =>
                      checkValidate(e, 'ccus_company_admin_password')
                    }
                  />
                  <label className='checkbox ccus-password-visible'>
                    <input
                      type='checkbox'
                      value={passwordVisible}
                      onChange={() => togglePasswordVisible(passwordVisible)}
                    />
                    <i className='i-square i-3x' />
                    {isOwner
                      ? messageUtility.getMessage('I-001-449')
                      : messageUtility.getMessage('I-001-515')}
                  </label>
                </FormElement>
              </FormListItem>
            )}
          </React.Fragment>
        ) : (
          <FormListItem
            label={
              isOwner ? 'CCUSログインパスワード' : 'CCUSセキュリティコード'
            }
            required={true}
          >
            <FormElement
              validate={_.get(messageValidate, 'ccus_company_admin_password')}
            >
              <TextInput
                tabIndex={
                  isCCUSFormEditable
                    ? TAB_KEY_STATUS.enabled
                    : TAB_KEY_STATUS.disabled
                }
                disabled={false}
                type={passwordVisible ? 'text' : 'password'}
                value={ccus_company_admin_password}
                autoComplete='new-password'
                onChange={e => setValue(e, 'ccus_company_admin_password')}
                onBlur={e => checkValidate(e, 'ccus_company_admin_password')}
              />
              <label className='checkbox ccus-password-visible'>
                <input
                  type='checkbox'
                  value={passwordVisible}
                  onChange={() => togglePasswordVisible(passwordVisible)}
                />
                <i className='i-square i-3x' />
                {isOwner
                  ? messageUtility.getMessage('I-001-449')
                  : messageUtility.getMessage('I-001-515')}
              </label>
            </FormElement>
          </FormListItem>
        )}
        <div className='CcusForm__ccus-explain'>
          <div className='CcusForm__ccus-explain--text'>
            <FormElementContainer style={{ maxWidth: '960px' }}>
              {messageUtility.getMessage('I-001-450')}
            </FormElementContainer>
          </div>
          <div>
            <img
              className='image'
              src={isOwner ? ccusExplainImageOfOwner : ccusExplainImageOfNotOwner}
              alt='img-ccus-explain'
            />
          </div>
        </div>
      </FormList>
      {isLoadingCcus && (
        <BackgroundLayer modalRoot='root' modalState={true}>
          {isLoadingCcus && <CcusConnectingDialog />}
        </BackgroundLayer>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/CcusCompanyForm.jsx